<template>
    <div class="select language">
        <select @change="onChange($event)" v-model="language">
            <option :value="supported_language.display" v-for="supported_language in supported_languages">
                {{ supported_language.display }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        props: {
            supported_languages: Array,
            language_display: String,
        },

        data(){
            return {
                language:""
            }
        },

        methods: {
            onChange(event){
                let selected_language = this.supported_languages.find( (element) => {
                    return element.display === this.language;

                });
                window.location.href = selected_language.url;

            }
        },

        mounted() {
            this.language = this.language_display
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .language{
        &::after{
            border-color: #ffffff;
        }
        select{
            background-color: transparent;
            color: #ffffff;
            width: 100%;
        }
    }
</style>
